import React from "react";
import { Dialog, IconButton, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function ImageViewerOverlay({ open, imageUrl, caption, onClose }) {
  if (!imageUrl) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          bgcolor: "transparent",
          boxShadow: "none",
          overflow: "hidden",
          m: 0,
          maxWidth: "100vw",
          maxHeight: "100vh",
        },
      }}
      slotProps={{
        backdrop: {
          sx: { bgcolor: "rgba(0,0,0,0.88)" },
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "fixed",
          top: 16,
          right: 16,
          color: "#fff",
          bgcolor: "rgba(0,0,0,0.45)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.65)" },
          zIndex: 1,
        }}
        aria-label="Close image"
      >
        <CloseIcon />
      </IconButton>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
          minHeight: "100vh",
          width: "100vw",
          boxSizing: "border-box",
        }}
        onClick={onClose}
      >
        <Box
          component="img"
          src={imageUrl}
          alt={caption || "image"}
          onClick={(e) => e.stopPropagation()}
          sx={{
            maxWidth: "95vw",
            maxHeight: caption ? "85vh" : "90vh",
            objectFit: "contain",
            borderRadius: 1,
          }}
        />
        {caption ? (
          <Typography
            variant="body2"
            onClick={(e) => e.stopPropagation()}
            sx={{
              color: "#fff",
              mt: 2,
              textAlign: "center",
              maxWidth: "90vw",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {caption}
          </Typography>
        ) : null}
      </Box>
    </Dialog>
  );
}

export default ImageViewerOverlay;
